// extracted by mini-css-extract-plugin
export default {"brand":"holdingsFilter_brand__2AqXL"};